// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB4hOHgvDeTUrhpNGxiRae0jqgjeLARYSo",
  authDomain: "gist-3e61b.firebaseapp.com",
  projectId: "gist-3e61b",
  storageBucket: "gist-3e61b.appspot.com",
  messagingSenderId: "21297306888",
  appId: "1:21297306888:web:931a053c0adc73f2bfa0bd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };